export default "__VITE_ASSET__DL9XdTKc__"